import { Connection, clusterApiUrl } from "@solana/web3.js";

export const getSolanaProvider = (wallet: any) => {
    const connection = new Connection(
        process.env.REACT_APP_SOLANA_RPC_URL || clusterApiUrl('devnet')
    );
    return {
        connection,
        wallet
    };
};
